export enum LayerType {
  Point = 'Point',
  Line = 'Line',
  Polygon = 'Polygon',
  MultiLine = 'MultiLine',
  MultiPolygon = 'MultiPolygon',
  LineString = 'LineString',
}

export enum LayerProtocol {
  WFS = 'WFS',
  WMS = 'WMS',
}

export enum ThematicType {
  Graduated = 'Graduated',
  Category = 'Category',
}

export type MapStyleDefinition = MapCssStyle | MapThematicStyle | string;

export class LayerDefinition {
  layerType: LayerType;
  layerProtocol: LayerProtocol = LayerProtocol.WFS;
  isThematic?: boolean = false;

  constructor(init: { layerType: LayerType; layerProtocol: LayerProtocol; isThematic?: boolean }) {
    Object.assign(this, init);
  }
}

export class MapCssDefinition {
  Fill?: string;
  Color?: string;
  Opacity?: number;
  Size?: number;
  iconPath?: string; // Only used for styles inside thematics
  Weight?: number;
}

export class MapCssNativeDefinition {
  color: string;
  opacity: number;
  fillColor: string;
  fillOpacity: number;
  iconPath?: string; // Only used for styles inside thematics
  weight?: number;
}

export class MapCssStyle {
  className?: string[];
  definition: MapCssDefinition;
}

export class MapThematicStyle {
  thematicType: ThematicType;
  className: string[];
  fieldName: string;
  rangeDefinition: { value: number; styleDefinition: MapCssStyle }[];
}
